export const SITUATION_SETS = {
  B1: [
    {
      id: 'situations-decisions-b1',
      title: 'Situations & Prise de décision',
      subtitle: 'Exprimez votre choix avec justification et contraste',
      questions: [
        {
          situation: "Tu dois choisir entre étudier seul à la maison ou étudier avec des amis à la bibliothèque.",
          consigne: "Explique ton choix et donne au moins deux raisons.",
          reponse: "Personnellement, je préfère étudier seul à la maison, car je suis plus concentré et je peux organiser mon temps comme je veux. Cependant, étudier avec des amis peut être utile pour échanger des idées et s'entraider.",
        },
        {
          situation: "Tu as un week-end libre. Tu peux soit rester chez toi pour te reposer, soit sortir avec tes amis.",
          consigne: "Que choisis-tu ? Explique pourquoi.",
          reponse: "Je préfère sortir avec mes amis, parce que cela me permet de me détendre et de changer d'air. Cependant, rester à la maison est aussi important pour se reposer, surtout après une semaine fatigante.",
        },
        {
          situation: "Tu veux apprendre une nouvelle langue. Tu peux utiliser une application ou prendre des cours avec un professeur.",
          consigne: "Quelle option choisis-tu ? Justifie ta réponse.",
          reponse: "Je choisis de prendre des cours avec un professeur, car je peux poser des questions et recevoir des explications claires. Cependant, les applications sont pratiques pour apprendre à son rythme.",
        },
        {
          situation: "Tu dois te déplacer en ville. Tu peux prendre le bus ou utiliser un vélo.",
          consigne: "Quel moyen de transport préfères-tu ? Pourquoi ?",
          reponse: "Je préfère utiliser un vélo, car c'est plus rapide dans la circulation et meilleur pour la santé. Cependant, le bus est plus pratique quand il pleut ou quand on est fatigué.",
        },
        {
          situation: "Tu dois préparer un repas. Tu peux cuisiner à la maison ou commander de la nourriture.",
          consigne: "Que choisis-tu ? Explique.",
          reponse: "Je préfère cuisiner à la maison, car c'est plus sain et moins cher. Cependant, commander de la nourriture est plus rapide quand on n'a pas le temps.",
        },
        {
          situation: "Tu veux regarder un film. Tu peux aller au cinéma ou rester chez toi.",
          consigne: "Quelle option préfères-tu ? Pourquoi ?",
          reponse: "Je préfère aller au cinéma, parce que l'expérience est plus immersive avec un grand écran. Cependant, regarder un film à la maison est plus confortable et moins coûteux.",
        },
        {
          situation: "Tu dois faire du sport. Tu peux aller à la salle de sport ou faire du sport à la maison.",
          consigne: "Que choisis-tu ? Justifie.",
          reponse: "Je préfère aller à la salle de sport, car il y a plus d'équipements et cela me motive davantage. Cependant, faire du sport à la maison est pratique et économique.",
        },
        {
          situation: "Tu dois acheter un cadeau. Tu peux acheter quelque chose en magasin ou en ligne.",
          consigne: "Quelle option préfères-tu ? Pourquoi ?",
          reponse: "Je préfère acheter en magasin, car je peux voir le produit avant de l'acheter. Cependant, acheter en ligne offre plus de choix et peut être plus rapide.",
        },
        {
          situation: "Tu veux passer tes vacances. Tu peux aller à la mer ou à la montagne.",
          consigne: "Que choisis-tu ? Explique.",
          reponse: "Je préfère aller à la montagne, car c'est calme et relaxant. Cependant, la mer est idéale pour se baigner et profiter du soleil.",
        },
        {
          situation: "Tu dois faire tes devoirs. Tu peux commencer tout de suite ou attendre plus tard.",
          consigne: "Que fais-tu ? Pourquoi ?",
          reponse: "Je préfère commencer tout de suite, car cela me permet de finir plus tôt et de me détendre après. Cependant, parfois j'attends un peu si je suis trop fatigué.",
        },
      ],
    },
  ],
  B2: [
    {
      id: 'situations-conflits-ethique-b2',
      title: 'Conflits, éthique & psychologie',
      subtitle: 'Analyse des situations complexes avec nuance',
      questions: [
        {
          situation: "La vérité qui blesse ou le mensonge qui protège ? Analyse les deux options et leurs conséquences psychologiques.",
          consigne: "Argumente pour chaque option et donne ta position.",
          reponse: "Dire la vérité peut être douloureux, mais elle permet de construire une relation sincère. En revanche, mentir peut protéger sur le moment, mais risque d'aggraver la situation plus tard.",
        },
        {
          situation: "Tu as un conflit générationnel avec un membre de ta famille sur un sujet important.",
          consigne: "Explique ton point de vue sans blesser.",
          reponse: "Je comprends votre point de vue, mais aujourd'hui les réalités ont changé. J'essaie de trouver un équilibre entre vos valeurs et mes choix.",
        },
        {
          situation: "Un ami utilise beaucoup l'autodérision. Tu te demandes si c'est de l'humour ou un signe de mal-être.",
          consigne: "Analyse la situation et propose une solution.",
          reponse: "Cela peut être une forme d'humour, mais aussi un signe de mal-être. Je lui parlerais avec tact pour comprendre ce qu'il ressent vraiment.",
        },
        {
          situation: "Tu observes une injustice sociale dans ton quartier ou ton école.",
          consigne: "Explique le problème et propose une solution.",
          reponse: "Cette situation est injuste car elle crée des inégalités. On pourrait sensibiliser davantage et proposer des solutions concrètes pour y remédier.",
        },
        {
          situation: "Tu as un collègue dont le comportement est imprévisible — parfois très sympathique, parfois distant.",
          consigne: "Analyse la situation et explique comment tu t'adaptes.",
          reponse: "Son comportement dépend probablement du contexte ou de son état émotionnel. Je m'adapte en restant professionnel et en évitant les conflits inutiles.",
        },
        {
          situation: "Quelqu'un a trahi ta confiance. Tu dois décider si tu lui donnes une deuxième chance.",
          consigne: "Explique ta décision.",
          reponse: "La confiance se reconstruit avec le temps, mais elle exige des preuves concrètes et de la cohérence. Je donnerais une chance, tout en restant vigilant.",
        },
        {
          situation: "Tu es dans une situation où tu dois montrer tes émotions en public (tristesse, colère, joie).",
          consigne: "Explique ta position sur l'expression des émotions.",
          reponse: "Montrer ses émotions est humain et parfois nécessaire, mais il faut savoir les gérer selon le contexte pour ne pas mettre les autres mal à l'aise.",
        },
        {
          situation: "Tu n'es pas d'accord avec quelqu'un mais tu veux exprimer ton désaccord intelligemment.",
          consigne: "Formule un désaccord respectueux.",
          reponse: "Je comprends ton point de vue, cependant je pense différemment. Voici pourquoi : les faits montrent que…",
        },
        {
          situation: "Tu te compares souvent aux autres sur les réseaux sociaux et cela affecte ton moral.",
          consigne: "Analyse ce phénomène et propose une solution.",
          reponse: "Comparer sa vie aux autres crée frustration et pression inutile. Il vaut mieux se concentrer sur son propre parcours et limiter le temps sur les réseaux.",
        },
        {
          situation: "On te dit que tu es « trop gentil(le) ». Est-ce un défaut ?",
          consigne: "Argumente.",
          reponse: "Être gentil est une qualité, mais sans limites, on peut être exploité. Il faut trouver un équilibre entre générosité et affirmation de soi.",
        },
      ],
    },
    {
      id: 'situations-societe-valeurs-b2',
      title: 'Société, valeurs & culture',
      subtitle: 'Réflexion sur les enjeux contemporains',
      questions: [
        {
          situation: "Jusqu'où va la liberté d'expression ? Peut-on tout dire ?",
          consigne: "Donne ta position avec des arguments.",
          reponse: "La liberté d'expression est essentielle dans une démocratie, mais elle doit avoir des limites pour éviter les abus, les discours de haine et la désinformation.",
        },
        {
          situation: "Faut-il préserver les traditions ou s'adapter à la modernité ?",
          consigne: "Argumente avec des exemples.",
          reponse: "Il faut préserver certaines traditions qui sont porteuses de sens tout en s'adaptant au monde moderne. L'équilibre entre les deux est la clé.",
        },
        {
          situation: "Les réseaux sociaux créent une pression sociale importante, surtout chez les jeunes.",
          consigne: "Analyse ce phénomène.",
          reponse: "Les réseaux créent une image irréaliste de la vie. Je prends du recul pour éviter cette pression et je me concentre sur ce qui est réel.",
        },
        {
          situation: "Les réseaux sociaux : outil utile ou danger pour la société ?",
          consigne: "Présente les deux aspects.",
          reponse: "Ils sont utiles pour communiquer et s'informer, mais peuvent être dangereux s'ils sont mal utilisés : désinformation, addiction, cyberharcèlement.",
        },
        {
          situation: "Le multiculturalisme est-il une richesse ou une source de conflits ?",
          consigne: "Exprime ton point de vue nuancé.",
          reponse: "C'est une richesse car il favorise l'ouverture d'esprit, mais cela peut créer des tensions sans dialogue et sans compréhension mutuelle.",
        },
        {
          situation: "Devrait-on enseigner la gestion des émotions à l'école ?",
          consigne: "Argumente.",
          reponse: "L'éducation émotionnelle est essentielle pour apprendre à gérer ses émotions, mieux communiquer et développer l'empathie dès le plus jeune âge.",
        },
        {
          situation: "« Une petite habitude peut changer une vie. » Es-tu d'accord ?",
          consigne: "Donne des exemples.",
          reponse: "Oui, une petite habitude répétée chaque jour peut transformer une vie sur le long terme : lire 10 minutes, faire du sport, écrire un journal.",
        },
        {
          situation: "Certaines personnes ordinaires ont un impact extraordinaire. Qui sont ces « héros ordinaires » ?",
          consigne: "Donne un exemple et explique.",
          reponse: "Les enseignants, les bénévoles, les parents — ces personnes ordinaires ont un impact extraordinaire par leurs actions quotidiennes et leur dévouement.",
        },
        {
          situation: "Vie lente ou vie rapide ? Quel rythme de vie préfères-tu ?",
          consigne: "Compare les deux modes de vie.",
          reponse: "La vie lente réduit le stress et permet de profiter du moment présent, mais la rapidité est parfois nécessaire dans le monde professionnel.",
        },
        {
          situation: "Quel est le rôle de l'art dans la société ?",
          consigne: "Explique avec des exemples.",
          reponse: "L'art est essentiel pour exprimer les émotions, questionner la société et créer du lien entre les cultures. Il peut aussi être un outil de changement social.",
        },
      ],
    },
    {
      id: 'situations-raisonnement-abstrait-b2',
      title: 'Raisonnement abstrait',
      subtitle: 'Questions hypothétiques et philosophiques',
      questions: [
        {
          situation: "Si tu pouvais changer une seule loi dans ton pays, laquelle choisirais-tu ?",
          consigne: "Explique ton choix et ses conséquences.",
          reponse: "Je modifierais cette loi pour la rendre plus équitable et adaptée à la société actuelle. Les conséquences seraient positives pour l'égalité des chances.",
        },
        {
          situation: "Imagine un monde sans argent. Comment fonctionnerait la société ?",
          consigne: "Décris ce monde hypothétique.",
          reponse: "La société fonctionnerait sur l'échange, la coopération et le partage des ressources. Cependant, de nouveaux problèmes d'organisation apparaîtraient.",
        },
        {
          situation: "Tu es seul(e) sur une île déserte. Quelles sont les compétences les plus importantes pour survivre ?",
          consigne: "Classe-les et justifie.",
          reponse: "L'adaptabilité, la coopération et l'intelligence pratique seraient essentielles. Savoir trouver de l'eau, construire un abri et garder le moral serait crucial.",
        },
        {
          situation: "Et si les humains ne pouvaient ressentir qu'une seule émotion ?",
          consigne: "Analyse les conséquences.",
          reponse: "Une seule émotion rendrait la société déséquilibrée. Sans tristesse, on ne pourrait pas apprécier la joie ; sans peur, on prendrait trop de risques.",
        },
        {
          situation: "Comment imagines-tu la vie quotidienne dans 50 ans ?",
          consigne: "Décris ton futur idéal.",
          reponse: "Le travail sera plus flexible grâce à la technologie, les relations plus numériques mais aussi plus conscientes. L'écologie sera au centre des décisions.",
        },
        {
          situation: "Si tu avais un double parfait de toi-même, comment serait la cohabitation ?",
          consigne: "Analyse.",
          reponse: "Ce serait à la fois intéressant et conflictuel, car nous penserions pareil. Les désaccords viendraient justement du fait de ne jamais avoir de perspective différente.",
        },
        {
          situation: "Si un objet de ton quotidien pouvait parler, lequel choisirais-tu et que dirait-il ?",
          consigne: "Sois créatif.",
          reponse: "Mon téléphone dirait probablement que je l'utilise trop et qu'il aimerait se reposer un peu. Il me conseillerait de regarder le monde réel.",
        },
        {
          situation: "Vivre dans un monde où tout le monde est surveillé en permanence : sécurité ou oppression ?",
          consigne: "Argumente.",
          reponse: "Ce serait une perte de liberté considérable malgré une sécurité accrue. La vie privée est un droit fondamental qu'il ne faut pas sacrifier.",
        },
        {
          situation: "Le « paradoxe du choix » : avoir trop d'options rend-il la vie plus difficile ?",
          consigne: "Explique avec des exemples.",
          reponse: "Oui, trop de choix crée de l'indécision et de l'anxiété. Par exemple, face à 50 séries sur une plateforme, on finit souvent par ne rien regarder.",
        },
        {
          situation: "Imagine un monde sans langage verbal. Comment communiqueraient les humains ?",
          consigne: "Décris les alternatives.",
          reponse: "On utiliserait les gestes, les expressions faciales et les émotions pour communiquer. L'art visuel et la musique deviendraient des langages universels.",
        },
      ],
    },
    {
      id: 'situations-reactions-1-b2',
      title: 'Réactions & communication I',
      subtitle: 'Situations professionnelles et relationnelles',
      questions: [
        {
          situation: "Ton collègue a pris le crédit pour ton travail devant le patron.",
          consigne: "Comment réagis-tu ?",
          reponse: "Je préfère vérifier les faits calmement avant de conclure. Ensuite, je parlerais à mon collègue en privé pour clarifier la situation avant d'impliquer le patron.",
        },
        {
          situation: "Ton entreprise propose le télétravail à 100 %. Est-ce une bonne chose ?",
          consigne: "Analyse les avantages et inconvénients.",
          reponse: "Le télétravail offre de la flexibilité et réduit le temps de transport, mais il peut isoler et rendre la communication d'équipe plus difficile.",
        },
        {
          situation: "Tu découvres qu'un camarade de classe a triché à un examen important.",
          consigne: "Que fais-tu ?",
          reponse: "Je lui parlerais d'abord en privé pour comprendre ses raisons. Ensuite, je l'encouragerais à corriger la situation lui-même plutôt que de le dénoncer directement.",
        },
        {
          situation: "On t'a refusé une opportunité que tu méritais. Tu te sens injustement traité(e).",
          consigne: "Exprime ta frustration de manière constructive.",
          reponse: "Je souhaite comprendre les raisons de ce refus. J'aimerais recevoir un retour constructif pour savoir comment m'améliorer pour la prochaine fois.",
        },
        {
          situation: "Les notes à l'école sont-elles un bon indicateur de compétence ?",
          consigne: "Argumente.",
          reponse: "Les notes mesurent certaines compétences, mais pas toutes. Elles doivent être complétées par d'autres formes d'évaluation comme les projets et la participation.",
        },
        {
          situation: "Ton meilleur ami a une opinion politique totalement opposée à la tienne.",
          consigne: "Comment gères-tu cette différence ?",
          reponse: "Je respecte son opinion même si je ne la partage pas. L'amitié ne doit pas dépendre de nos idées politiques mais de nos valeurs communes.",
        },
        {
          situation: "Deux amis te proposent des plans différents pour le même jour. Tu dois choisir.",
          consigne: "Comment trouves-tu un compromis ?",
          reponse: "Je proposerais de combiner les deux activités si possible, ou d'expliquer honnêtement mon choix en proposant une alternative pour l'autre ami.",
        },
        {
          situation: "Tu ressens une émotion complexe que tu n'arrives pas à nommer.",
          consigne: "Décris cette émotion et essaie de l'analyser.",
          reponse: "Je suis partagé entre l'excitation et le stress, comme lorsqu'on commence quelque chose de nouveau. C'est un mélange d'espoir et d'incertitude.",
        },
        {
          situation: "Raconte une expérience difficile qui t'a fait grandir.",
          consigne: "Utilise des connecteurs temporels.",
          reponse: "D'abord, j'ai eu peur de l'échec. Ensuite, j'ai compris que cela m'a permis de grandir et de développer ma résilience. Finalement, cette épreuve m'a rendu plus fort.",
        },
        {
          situation: "On critique injustement ton travail lors d'une réunion.",
          consigne: "Réponds de manière professionnelle.",
          reponse: "Je vous remercie pour votre retour. Cependant, permettez-moi d'expliquer mon raisonnement et les choix que j'ai faits pour ce projet.",
        },
      ],
    },
    {
      id: 'situations-reactions-2-b2',
      title: 'Réactions & communication II',
      subtitle: 'Situations sociales et argumentation avancée',
      questions: [
        {
          situation: "Un ami traverse une période difficile et doute de lui-même.",
          consigne: "Encourage-le avec des mots sincères.",
          reponse: "C'est normal d'avoir peur et de douter de soi. Mais je te connais, tu es capable de surmonter cette épreuve. Tu peux compter sur moi.",
        },
        {
          situation: "Quelqu'un te demande un conseil important sur sa carrière.",
          consigne: "Donne un conseil structuré.",
          reponse: "Avant de décider, réfléchis à ce qui te passionne vraiment. Pèse le pour et le contre. Et surtout, ne prends pas cette décision sous la pression des autres.",
        },
        {
          situation: "Quelqu'un t'interrompt constamment quand tu parles.",
          consigne: "Comment réagis-tu avec respect ?",
          reponse: "J'aimerais pouvoir terminer mon idée, s'il te plaît. Je t'écouterai avec attention ensuite. La communication fonctionne mieux quand chacun peut s'exprimer.",
        },
        {
          situation: "Tu lis un article controversé sur un sujet d'actualité.",
          consigne: "Donne ton avis nuancé.",
          reponse: "C'est une mesure qui peut être utile dans certains contextes, mais elle serait difficile à appliquer universellement. Il faudrait adapter l'approche selon les situations.",
        },
        {
          situation: "Un malentendu crée une tension entre toi et un(e) ami(e).",
          consigne: "Résous le malentendu.",
          reponse: "Je pense qu'il y a eu un malentendu entre nous. Parlons directement et honnêtement pour clarifier la situation et éviter que cela se reproduise.",
        },
        {
          situation: "Le stress chez les jeunes augmente chaque année. Pourquoi ?",
          consigne: "Analyse les causes et propose des solutions.",
          reponse: "Les attentes sociales, scolaires et professionnelles sont très fortes. Pour réduire ce stress, il faudrait valoriser le bien-être autant que la performance.",
        },
        {
          situation: "La culture du « tout jetable » pose un problème écologique majeur.",
          consigne: "Propose des alternatives.",
          reponse: "Il faut encourager la réparation, le recyclage et la consommation responsable. Chaque petit geste compte pour réduire notre impact environnemental.",
        },
        {
          situation: "Tu dois convaincre quelqu'un d'essayer quelque chose de nouveau.",
          consigne: "Utilise des arguments persuasifs.",
          reponse: "C'est une excellente opportunité d'apprendre et de sortir de ta zone de confort. Tu n'as rien à perdre et tout à gagner en essayant.",
        },
        {
          situation: "Tu attends une décision importante depuis longtemps et tu perds patience.",
          consigne: "Exprime ta frustration poliment.",
          reponse: "L'attente est difficile, surtout sans information. Je souhaiterais avoir un retour, même partiel, pour pouvoir m'organiser et avancer sereinement.",
        },
        {
          situation: "Certaines langues minoritaires disparaissent chaque année.",
          consigne: "Pourquoi est-ce un problème et que peut-on faire ?",
          reponse: "Les langues sont une richesse culturelle irremplaçable à préserver. Leur disparition signifie la perte d'histoires, de savoirs et d'identités uniques. Il faut soutenir leur enseignement.",
        },
      ],
    },
  ],
};
